// Mutation hook - utworzenie nowego dealu z watku Notify PENDING_REVIEW.
// POST /api/ui/sales-crm/notify/threads/{threadId}/create-deal-from-thread
// Sprint 4 v4.1.

import { axios } from 'api';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type {
  IPostCreateDealFromThreadRequest,
  IPostCreateDealFromThreadResponse
} from 'api/types/notify';
import { NOTIFY_INBOX_QUERY_KEY_BASE } from 'api/endpoints/useGetNotifyInbox';

export interface IUsePostCreateDealFromThreadVariables {
  threadId: number;
  body: IPostCreateDealFromThreadRequest;
}

const postCreateDealFromThread = ({
  threadId,
  body
}: IUsePostCreateDealFromThreadVariables): Promise<IPostCreateDealFromThreadResponse> =>
  axios.post(`/sales-crm/notify/threads/${threadId}/create-deal-from-thread`, body);

export const usePostCreateDealFromThread = (
  options?: UseMutationOptions<
    IPostCreateDealFromThreadResponse,
    IError,
    IUsePostCreateDealFromThreadVariables
  >
) => {
  const queryClient = useQueryClient();
  return useMutation<
    IPostCreateDealFromThreadResponse,
    IError,
    IUsePostCreateDealFromThreadVariables
  >(postCreateDealFromThread, {
    ...options,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries(NOTIFY_INBOX_QUERY_KEY_BASE);
      await queryClient.invalidateQueries(['sales-crm-deals']);
      await queryClient.invalidateQueries(['sales-crm-deals-kanban']);
      await queryClient.invalidateQueries(['sales-crm-notify']);
      options?.onSuccess?.(data, variables, context);
    }
  });
};
